import React from "react";

const LoadingState = ({ label = "Loading..." }) => (
  <div className="flex flex-col items-center justify-center p-12 text-slate-400 h-full min-h-[200px]">
    <div className="w-8 h-8 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mb-4"></div>
    <p className="text-sm font-medium">{label}</p>
  </div>
);

export default LoadingState;
